<div fxLayout="column">
    <div class="mt-8 ml-8">
        <h3>{{"CASES.CREATE_CASE" | translate}}</h3>
    </div>
    <!-- <div fxFlex="100" class="my-4"> -->
        <div [formGroup]="form" style="width: 100%;">
            <div class="p-4">
                <mat-form-field class="m-4" appearance="outline" style="width: 100%;">
                    <mat-label>{{"CASES.CASE_TITLE" | translate}}</mat-label>
                    <input class="p-8" matInput formControlName="caseTitle" />
                </mat-form-field>
                <div align="end">
                    <mat-hint>{{titleInputLenght}} / {{maxLength}}</mat-hint>
                </div>
            </div>
    
            <div class="p-4">
                <mat-form-field class="m-4" appearance="outline" floatLabel="always" style="width: 100%;">
                    <mat-label>{{"CASES.SUMMARY" | translate}}</mat-label>
                    <textarea matInput rows="6" #textarea formControlName="caseSummary" maxlength="1024">
                    </textarea>
                </mat-form-field>
                <div align="end">
                    <mat-hint>{{summaryInputLenght}} / {{maxLength}}</mat-hint>
                </div>
            </div>
        </div>
    <!-- </div> -->
</div>
